import { render, staticRenderFns } from "./cellWidth-editor.vue?vue&type=template&id=5637dccb&scoped=true"
import script from "./cellWidth-editor.vue?vue&type=script&lang=js"
export * from "./cellWidth-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637dccb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5637dccb')) {
      api.createRecord('5637dccb', component.options)
    } else {
      api.reload('5637dccb', component.options)
    }
    module.hot.accept("./cellWidth-editor.vue?vue&type=template&id=5637dccb&scoped=true", function () {
      api.rerender('5637dccb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-table-cell/cellWidth-editor.vue"
export default component.exports